import React from 'react';
import { getFileTypeIcon, getFileIconPath, getFileIconAltText, getFileIconSvgContent, FileTypeIcon } from '../../utils/fileTypeUtils';
import { TbBrandDatabricks } from "react-icons/tb";
import { FaFileCsv } from "react-icons/fa6";
import { BsFiletypeXlsx } from "react-icons/bs";

interface FileIconProps {
    fileName?: string;
    fileType?: string;
    className?: string;
    /** Optional override for icon type */
    iconType?: FileTypeIcon;
}

/**
 * FileIcon component that displays the appropriate icon for a file type
 * Supports both inline SVG content and external image files
 */
export const FileIcon: React.FC<FileIconProps> = ({
    fileName = '',
    fileType = '',
    className = 'w-6 h-6',
    iconType
}) => {
    const detectedIconType = iconType || getFileTypeIcon(fileName, fileType);
    const altText = getFileIconAltText(detectedIconType);

    // Use React Icons with red theme styling matching folder icons
    const iconStyle = {
        color: '#D31145', // Red theme color
        width: '80%',
        height: '80%'
    };

    switch (detectedIconType) {
        case 'csv-doc':
            return (
                <div className={`${className} flex items-center justify-center`} aria-label={altText} role="img">
                    <FaFileCsv style={iconStyle} />
                </div>
            );
        case 'xlsx':
            return (
                <div className={`${className} flex items-center justify-center`} aria-label={altText} role="img">
                    <BsFiletypeXlsx style={iconStyle} />
                </div>
            );
        case 'databricks':
            return (
                <div className={`${className} flex items-center justify-center`} aria-label={altText} role="img">
                    <TbBrandDatabricks style={iconStyle} />
                </div>
            );
        default:
            // Fallback generic document icon
            return (
                <svg
                    className={`${className} flex-shrink-0`}
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-label={altText}
                    style={{ color: '#6B7280' }}
                >
                    <path
                        fillRule="evenodd"
                        d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625zM7.5 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 017.5 15zm.75-6.75a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5z"
                        clipRule="evenodd"
                    />
                </svg>
            );
    }
};

export default FileIcon;